export default __webpack_public_path__ + "f08e02b1252e78ae2924100dfcb8428c.svg";